<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p><span class="breadcrumb-item" @click="$router.push('/')">Inicio</span> > Publicidad Meta</p>
    </div>
  </div>

  <div class="px-4 container-fluid">

    <!-- Cabecera -->
    <div class="pub-header mb-4">
      <div>
        <h4 class="pub-title">Publicidad Meta</h4>
        <p class="pub-subtitle">Datos de campañas cruzados con ventas de Quanty</p>
      </div>
      <div class="pub-header-actions">
        <button class="btn-pub-secondary" @click="sincronizar" :disabled="sincronizando">
          <i :class="sincronizando ? 'fa fa-spinner fa-spin' : 'fa fa-refresh'"></i>
          {{ sincronizando ? 'Sincronizando...' : 'Sincronizar Meta' }}
        </button>
        <button class="btn-pub-secondary" @click="abrirModalEnlace" :disabled="cargandoEnlace">
          <i :class="cargandoEnlace ? 'fa fa-spinner fa-spin' : 'fa fa-link'"></i>
          {{ cargandoEnlace ? 'Cargando...' : 'Enlazar campañas' }}
        </button>
        <button class="btn-pub-secondary" @click="exportarExcel" :disabled="!filas.length">
          <i class="fa fa-file-excel-o"></i> Exportar Excel
        </button>
        <button class="btn-pub-secondary" @click="exportarJson" :disabled="exportandoJson || !filtros.desde || !filtros.hasta" :title="!filtros.desde || !filtros.hasta ? 'Selecciona un rango de fechas' : ''">
          <i :class="exportandoJson ? 'fa fa-spinner fa-spin' : 'fa fa-download'"></i>
          {{ exportandoJson ? 'Generando...' : 'Descargar JSON' }}
        </button>
        <button class="btn-pub-secondary btn-pub-informe" @click="abrirModalInforme">
          <i class="fa fa-bar-chart"></i> Informe
        </button>
      </div>
    </div>

    <!-- Filtros -->
    <div class="card pub-card mb-4">

      <!-- Fila 1: Tipster + Campaña (solo si hay datos) -->
      <div class="pub-filtros pub-filtros--entidad mb-3"
           v-if="filtroOpciones.tipsters.length || filtroOpciones.campanas.length">
        <div class="filtro-group" v-if="filtroOpciones.tipsters.length">
          <label class="filtro-label">Tipster</label>
          <select v-model="filtros.tipster_id" class="filtro-input filtro-input--wide" @change="onCambioTipster">
            <option value="">Todos los tipsters</option>
            <option v-for="t in filtroOpciones.tipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
          </select>
        </div>

        <div class="filtro-group" v-if="filtroOpciones.campanas.length">
          <label class="filtro-label">Campaña Quanty</label>
          <select v-model="filtros.campana_id" class="filtro-input filtro-input--wide">
            <option value="">Todas las campañas</option>
            <option v-for="c in campanasFiltradas" :key="c.id" :value="c.id">
              {{ c.eliminada ? '🗑 ' : '' }}{{ c.nombre }}
            </option>
          </select>
        </div>

        <div class="filtro-group filtro-group--center">
          <label class="filtro-toggle">
            <input type="checkbox" v-model="filtros.con_eliminadas" @change="cargarFiltros" />
            <span>Ver eliminadas</span>
          </label>
        </div>

        <div v-if="filtros.tipster_id || filtros.campana_id" class="filtro-group filtro-group--center">
          <button class="btn-filtro-clear" @click="limpiarEntidad" title="Quitar filtros de tipster y campaña">
            <i class="fa fa-times"></i> Limpiar
          </button>
        </div>
      </div>

      <!-- Separador si hay fila de entidades -->
      <div v-if="filtroOpciones.tipsters.length || filtroOpciones.campanas.length"
           class="pub-filtros-sep mb-3"></div>

      <!-- Fila 2: Fecha + Nivel + Columnas + Buscar -->
      <div class="pub-filtros">
        <!-- Presets de fecha -->
        <div class="filtro-group">
          <label class="filtro-label">Período</label>
          <div class="preset-btns">
            <button v-for="p in PRESETS" :key="p.days"
              class="btn-preset" :class="{ active: presetActivo === p.days }"
              @click="aplicarPreset(p.days)">{{ p.label }}</button>
          </div>
        </div>

        <!-- Fechas personalizadas -->
        <div class="filtro-group">
          <label class="filtro-label">Desde</label>
          <input type="date" v-model="filtros.desde" class="filtro-input" @change="presetActivo = null" />
        </div>
        <div class="filtro-group">
          <label class="filtro-label">Hasta</label>
          <input type="date" v-model="filtros.hasta" class="filtro-input" @change="presetActivo = null" />
        </div>

        <!-- Nivel -->
        <div class="filtro-group">
          <label class="filtro-label">Nivel</label>
          <select v-model="filtros.level" class="filtro-input">
            <option value="campaign">Campaña</option>
            <option value="adset">Adset</option>
            <option value="ad">Anuncio</option>
          </select>
        </div>

        <!-- Columnas -->
        <div class="filtro-group" v-click-outside="cerrarColumnPicker">
          <label class="filtro-label">Columnas</label>
          <button class="btn-column-picker" @click="mostrarColumnPicker = !mostrarColumnPicker">
            <i class="fa fa-columns"></i> {{ columnasVisibles.length }} visibles
          </button>
          <div v-if="mostrarColumnPicker" class="column-picker-panel">
            <div class="cp-header">
              <span>Personalizar columnas</span>
              <div class="cp-actions">
                <button class="cp-link" @click="seleccionarTodas">Todas</button>
                <span class="cp-sep">·</span>
                <button class="cp-link" @click="seleccionarMinimas">Mínimas</button>
              </div>
            </div>
            <div v-for="grupo in GRUPOS_COLUMNAS" :key="grupo.label" class="cp-group">
              <div class="cp-group-label">{{ grupo.label }}</div>
              <label v-for="col in grupo.cols" :key="col.key" class="cp-row">
                <input type="checkbox" v-model="columnasActivas" :value="col.key" />
                <span>{{ col.label }}</span>
              </label>
            </div>
          </div>
        </div>

        <button class="btn-pub-primary" @click="cargar" :disabled="cargando">
          <i :class="cargando ? 'fa fa-spinner fa-spin' : 'fa fa-search'"></i>
          {{ cargando ? 'Cargando...' : 'Buscar' }}
        </button>
      </div>

      <!-- Búsqueda manual en tabla -->
      <div v-if="filas.length" class="busqueda-row">
        <div class="busqueda-wrap">
          <i class="fa fa-search busqueda-icon"></i>
          <input
            v-model="busquedaTexto"
            type="text"
            class="busqueda-input"
            placeholder="Filtrar por campaña, adset, anuncio o plantilla…"
          />
          <button v-if="busquedaTexto" class="busqueda-clear" @click="busquedaTexto = ''">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <span v-if="busquedaTexto" class="busqueda-count">
          {{ filasOrdenadas.length }} de {{ filas.length }} filas
        </span>
      </div>
    </div>

    <!-- KPI resumen -->
    <div class="kpi-row mb-4" v-if="filas.length">
      <div class="kpi-card">
        <span class="kpi-label">Inversión total</span>
        <span class="kpi-value">{{ fmt.eur(totales.spend) }}</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Ingresos Quanty</span>
        <span class="kpi-value kpi-green">
          <template v-if="totales.ingresos_eur > 0">{{ fmt.eur(totales.ingresos_eur) }}</template>
          <template v-if="totales.ingresos_eur > 0 && totales.ingresos_usd > 0"> · </template>
          <template v-if="totales.ingresos_usd > 0"><span style="color:#26c6da">${{ Number(totales.ingresos_usd).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}) }}</span></template>
          <template v-if="!totales.ingresos_eur && !totales.ingresos_usd">{{ fmt.eur(0) }}</template>
        </span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">ROAS real</span>
        <span class="kpi-value" :class="totales.roas_real >= 1 ? 'kpi-green' : 'kpi-red'">
          {{ totales.roas_real ? totales.roas_real.toFixed(2) + 'x' : '—' }}
        </span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Compras Quanty</span>
        <span class="kpi-value">{{ totales.compras_quanty }}</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">CPA real</span>
        <span class="kpi-value">{{ totales.compras_quanty ? fmt.eur(totales.spend / totales.compras_quanty) : '—' }}</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Impresiones</span>
        <span class="kpi-value">{{ fmt.num(totales.impressions) }}</span>
      </div>
    </div>

    <!-- Tabla -->
    <div class="card pub-card">
      <div v-if="cargando" class="pub-loading">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p>Cargando datos de Meta...</p>
      </div>

      <div v-else-if="!filas.length && buscado" class="pub-empty">
        <i class="fa fa-bar-chart fa-2x mb-3"></i>
        <p>No hay datos para el período seleccionado.</p>
        <p class="pub-empty-hint">Haz clic en <strong>Sincronizar Meta</strong> para importar datos.</p>
      </div>

      <div v-else-if="filas.length" class="tabla-wrap">
        <table class="pub-table">
          <thead>
            <tr>
              <th v-for="col in columnasVisiblesConfig" :key="col.key"
                class="pub-th" :class="col.align || 'text-right'"
                @click="ordenarPor(col.key)" style="cursor:pointer">
                {{ col.label }}
                <i v-if="orden.key === col.key"
                  :class="orden.asc ? 'fa fa-sort-asc' : 'fa fa-sort-desc'" class="ml-1"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fila, i) in filasOrdenadas" :key="i" class="pub-tr">
              <td v-for="col in columnasVisiblesConfig" :key="col.key"
                class="pub-td" :class="col.align || 'text-right'">
                <span :class="col.class?.(fila)" v-if="col.html" v-html="col.render(fila)"></span>
                <span :class="col.class?.(fila)" v-else>{{ col.render(fila) }}</span>
                <span v-if="col.sub?.(fila)" class="pub-td-sub">{{ col.sub(fila) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="pub-empty">
        <i class="fa fa-bar-chart fa-2x mb-3"></i>
        <p>Selecciona un período y haz clic en <strong>Buscar</strong>.</p>
      </div>
    </div>

    <!-- Modal vincular campañas Meta -->
    <div v-if="modalVincular" class="vinc-overlay" @click.self="modalVincular = false">
      <div class="vinc-modal">
        <div class="vinc-header">
          <div>
            <h5 class="vinc-title">Campañas detectadas en Meta</h5>
            <p class="vinc-subtitle">Asigna cada campaña a una landing de Quanty para poder filtrar por tipster y ver el ROAS real.</p>
          </div>
          <button class="vinc-close" @click="modalVincular = false"><i class="fa fa-times"></i></button>
        </div>

        <div v-if="!filtroOpciones.tipsters.length" class="vinc-empty">
          <i class="fa fa-info-circle"></i>
          No hay campañas Quanty configuradas. Crea una landing en <strong>Campañas</strong> primero y vuelve a sincronizar.
        </div>

        <template v-else>
          <!-- Barra de filtros -->
          <div class="vinc-filtros">
            <input class="vinc-filtro-search" type="text" placeholder="Buscar campaña…"
              v-model="vincFiltros.busqueda" @input="vincPagina = 1" />

            <select class="vinc-select vinc-filtro-tipster" v-model="vincFiltros.tipster_id" @change="onCambioFiltroTipster">
              <option value="">— Todos los tipsters —</option>
              <option v-for="t in filtroOpciones.tipsters" :key="t.id" :value="String(t.id)">{{ t.nombre }}</option>
            </select>

            <div class="vinc-filtro-tabs">
              <button :class="['vinc-tab', vincFiltros.asignacion === 'todos' && 'vinc-tab--active']"
                @click="vincFiltros.asignacion = 'todos'; vincPagina = 1">Todos</button>
              <button :class="['vinc-tab', vincFiltros.asignacion === 'sin' && 'vinc-tab--active']"
                @click="vincFiltros.asignacion = 'sin'; vincPagina = 1">Sin asignar</button>
              <button :class="['vinc-tab', vincFiltros.asignacion === 'con' && 'vinc-tab--active']"
                @click="vincFiltros.asignacion = 'con'; vincPagina = 1">Asignadas</button>
            </div>

            <div class="vinc-filtro-fechas">
              <input class="vinc-filtro-fecha" type="date" v-model="vincFiltros.desde" @change="vincPagina = 1" title="Desde" />
              <span class="vinc-filtro-sep">—</span>
              <input class="vinc-filtro-fecha" type="date" v-model="vincFiltros.hasta" @change="vincPagina = 1" title="Hasta" />
            </div>
          </div>

          <!-- Contador -->
          <div class="vinc-counter">
            {{ campanasVincFiltradas.length }} campaña{{ campanasVincFiltradas.length !== 1 ? 's' : '' }}
            <span v-if="vincFiltros.asignacion === 'sin' || vincFiltros.tipster_id || vincFiltros.busqueda || vincFiltros.desde || vincFiltros.hasta"> filtradas</span>
            · página {{ vincPagina }}/{{ campanasVincTotalPags }}
          </div>

          <div class="vinc-body">
            <div v-if="campanasVincPaginadas.length === 0" class="vinc-empty">
              <i class="fa fa-search"></i> No hay campañas con los filtros actuales.
            </div>
            <div v-for="c in campanasVincPaginadas" :key="c.meta_campaign_id" class="vinc-row">
              <div class="vinc-meta-name" :title="c.meta_campaign_id">
                <span class="vinc-badge">Meta</span>
                <div class="vinc-meta-info">
                  <span class="vinc-meta-nombre">{{ c.meta_campaign_name || c.meta_campaign_id }}</span>
                  <span v-if="c.fecha_max" class="vinc-meta-fecha">{{ fmtFechaVinc(c.fecha_max) }}</span>
                </div>
                <span v-if="vinculaciones[c.meta_campaign_id]?.campana_id" class="vinc-badge-linked">Enlazada</span>
              </div>
              <div class="vinc-selects">
                <select class="vinc-select"
                  v-model="vinculaciones[c.meta_campaign_id].tipster_id"
                  @change="onCambioTipsterVinculo(c.meta_campaign_id)">
                  <option value="">— Tipster —</option>
                  <option v-for="t in filtroOpciones.tipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
                </select>
                <!-- Dropdown con búsqueda y agrupación por fecha -->
                <div class="vinc-dd"
                  :class="{ 'vinc-dd--disabled': !vinculaciones[c.meta_campaign_id].tipster_id }"
                  v-click-outside="() => cerrarDropdownCampana(c.meta_campaign_id)">
                  <button class="vinc-dd-trigger"
                    type="button"
                    :disabled="!vinculaciones[c.meta_campaign_id].tipster_id"
                    @click="toggleDropdownCampana(c.meta_campaign_id)">
                    <span class="vinc-dd-valor">
                      {{ campanaNombrePorId(vinculaciones[c.meta_campaign_id].campana_id) || '— Campaña Quanty —' }}
                    </span>
                    <i class="fa fa-chevron-down vinc-dd-chevron"
                      :style="abrirDropdownCampana === c.meta_campaign_id ? 'transform:rotate(180deg)' : ''"></i>
                  </button>
                  <div v-if="abrirDropdownCampana === c.meta_campaign_id" class="vinc-dd-panel">
                    <div class="vinc-dd-search-wrap">
                      <i class="fa fa-search vinc-dd-search-icon"></i>
                      <input class="vinc-dd-search-input"
                        type="text"
                        placeholder="Buscar campaña..."
                        v-model="busquedaCampana[c.meta_campaign_id]"
                        @click.stop>
                    </div>
                    <div class="vinc-dd-scroll">
                      <div class="vinc-dd-opt vinc-dd-opt--none"
                        @click="seleccionarCampanaVinculo(c.meta_campaign_id, '')">
                        — Campaña Quanty —
                      </div>
                      <template v-if="gruposCampanasVinculo(c.meta_campaign_id).length">
                        <template v-for="grupo in gruposCampanasVinculo(c.meta_campaign_id)" :key="grupo.fecha">
                          <div class="vinc-dd-date-header">{{ formatFechaGrupo(grupo.fecha) }}</div>
                          <div v-for="camp in grupo.campanas" :key="camp.id"
                            class="vinc-dd-opt"
                            :class="{ 'vinc-dd-opt--active': String(vinculaciones[c.meta_campaign_id].campana_id) === String(camp.id) }"
                            @click="seleccionarCampanaVinculo(c.meta_campaign_id, camp.id)">
                            {{ camp.nombre }}
                          </div>
                        </template>
                      </template>
                      <div v-else class="vinc-dd-empty">Sin resultados</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Paginación -->
          <div v-if="campanasVincTotalPags > 1" class="vinc-paginacion">
            <button class="vinc-pag-btn" :disabled="vincPagina <= 1" @click="vincPagina--">
              <i class="fa fa-chevron-left"></i>
            </button>
            <button v-for="p in campanasVincTotalPags" :key="p"
              :class="['vinc-pag-num', vincPagina === p && 'vinc-pag-num--active']"
              @click="vincPagina = p">{{ p }}</button>
            <button class="vinc-pag-btn" :disabled="vincPagina >= campanasVincTotalPags" @click="vincPagina++">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </template>

        <div class="vinc-footer">
          <button class="vinc-btn-skip" @click="modalVincular = false">Omitir por ahora</button>
          <button class="vinc-btn-save" @click="guardarVinculos"
            :disabled="guardandoVinculos || !vinculosParaEnviar.length">
            <i :class="guardandoVinculos ? 'fa fa-spinner fa-spin' : 'fa fa-link'"></i>
            {{ guardandoVinculos ? 'Guardando...' : `Guardar vínculos (${vinculosParaEnviar.length})` }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Informe por País -->
    <div v-if="modalInforme" class="inf-overlay" @click.self="modalInforme = false">
      <div class="inf-modal">
        <!-- Header con logo -->
        <div class="inf-header">
          <div class="inf-header-logo">
            <img :src="quantyLogoUrl" alt="Quanty" class="inf-logo" />
            <div>
              <div class="inf-titulo">Resumen de Campañas</div>
              <div class="inf-subtitulo">Desglose por País</div>
            </div>
          </div>
          <button class="inf-close" @click="modalInforme = false"><i class="fa fa-times"></i></button>
        </div>

        <!-- Filtros del informe -->
        <div class="inf-filtros">
          <div class="filtro-group">
            <label class="filtro-label">Tipster</label>
            <select v-model="informeFiltros.tipster_id" class="filtro-input filtro-input--wide">
              <option value="">Todos los tipsters</option>
              <option v-for="t in filtroOpciones.tipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
            </select>
          </div>
          <div class="filtro-group">
            <label class="filtro-label">Desde</label>
            <input type="date" v-model="informeFiltros.desde" class="filtro-input" />
          </div>
          <div class="filtro-group">
            <label class="filtro-label">Hasta</label>
            <input type="date" v-model="informeFiltros.hasta" class="filtro-input" />
          </div>
          <div class="filtro-group filtro-group--center" style="flex-direction:row;gap:8px">
            <button class="btn-inf-generar" @click="generarInforme" :disabled="generandoInforme || !informeValido">
              <i :class="generandoInforme ? 'fa fa-spinner fa-spin' : 'fa fa-bar-chart'"></i>
              {{ generandoInforme ? 'Generando...' : 'Generar' }}
            </button>
            <button v-if="informeFilas.length" class="btn-inf-pdf" @click="imprimirInforme">
              <i class="fa fa-print"></i> PDF
            </button>
          </div>
        </div>

        <!-- Tabla de resultados -->
        <div v-if="informeFilas.length" class="inf-tabla-wrap">
          <table class="inf-tabla">
            <thead>
              <tr>
                <th>País</th>
                <th class="td-num">Gastado</th>
                <th class="td-num">Suscriptores</th>
                <th class="td-num">Coste susc.</th>
                <th class="td-num">Total ventas</th>
                <th class="td-num">Retorno</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="fila in informeFilas" :key="fila.pais">
                <td class="td-pais">
                  <span v-if="fila.pais && fila.pais !== '—'" class="fi fis inf-flag" :class="`fi-${paisToFlag(fila.pais)}`"></span>
                  <span class="inf-pais-nombre">{{ fila.pais }}</span>
                </td>
                <td class="td-num">${{ fmtNum(fila.gastado) }}</td>
                <td class="td-num">{{ fila.suscriptores }}</td>
                <td class="td-num">{{ fila.coste_susc != null ? '$' + fmtNum(fila.coste_susc) : '—' }}</td>
                <td class="td-num">{{ fila.total_ventas }}</td>
                <td class="td-num inf-retorno" :class="fila.retorno >= 1 ? 'pos' : fila.retorno != null ? 'neg' : ''">
                  {{ fila.retorno != null ? fmtNum(fila.retorno) + 'x' : '—' }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="inf-total-row">
                <td><strong>Total</strong></td>
                <td class="td-num"><strong>${{ fmtNum(informeTotales.gastado) }}</strong></td>
                <td class="td-num"><strong>{{ informeTotales.suscriptores }}</strong></td>
                <td class="td-num"><strong>{{ informeTotales.suscriptores > 0 ? '$' + fmtNum(informeTotales.gastado / informeTotales.suscriptores) : '—' }}</strong></td>
                <td class="td-num"><strong>{{ informeTotales.ventas }}</strong></td>
                <td class="td-num inf-retorno" :class="informeTotales.retorno >= 1 ? 'pos' : informeTotales.retorno > 0 ? 'neg' : ''">
                  <strong>{{ informeTotales.gastado > 0 ? fmtNum(informeTotales.ingresos / informeTotales.gastado) + 'x' : '—' }}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div v-else-if="informeBuscado && !generandoInforme" class="inf-empty">
          <i class="fa fa-inbox"></i> Sin datos para el período seleccionado.
        </div>
      </div>
    </div>

    <!-- Toasts -->
    <div v-if="toast.msg" class="pub-toast" :class="'pub-toast--' + toast.tipo">
      <i :class="toast.tipo === 'ok' ? 'fa fa-check-circle' : 'fa fa-exclamation-circle'"></i>
      {{ toast.msg }}
    </div>
  </div>
</template>

<script>
import metaInsightsService from "@/services/metaInsights.service";

const PRESETS = [
  { label: "Todo", days: null },
  { label: "7d",   days: 7  },
  { label: "14d",  days: 14 },
  { label: "30d",  days: 30 },
  { label: "90d",  days: 90 },
];

const fmt = {
  eur: (v) => v != null ? "€" + Number(v).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "—",
  num: (v) => v != null ? Number(v).toLocaleString("es-ES") : "—",
  pct: (v) => v != null ? Number(v).toFixed(2) + "%" : "—",
  x:   (v) => v != null ? Number(v).toFixed(2) + "x" : "—",
};

const TODAS_COLUMNAS = [
  // Identificación
  { key: "meta_campaign_name", label: "Campaña Meta", align: "text-left",  render: r => r.meta_campaign_name || "—", sub: r => r.campana_quanty_nombre ? `Enlazada a: ${r.campana_quanty_nombre}` : null },
  { key: "plantilla_nombre",   label: "Plantilla",   align: "text-left",  render: r => r.plantilla_nombre || "—", sub: r => r.landing_slug ? `/${r.landing_slug}` : null },
  { key: "meta_adset_name",    label: "Adset",      align: "text-left",  render: r => r.meta_adset_name    || "—" },
  { key: "meta_ad_name",       label: "Anuncio",    align: "text-left",  render: r => r.meta_ad_name       || "—" },
  // Inversión
  { key: "spend",        label: "Inversión",    render: r => fmt.eur(r.spend) },
  // Alcance
  { key: "impressions",  label: "Impresiones",  render: r => fmt.num(r.impressions) },
  { key: "reach",        label: "Alcance",      render: r => fmt.num(r.reach) },
  { key: "frequency",    label: "Frecuencia",   render: r => r.frequency ? Number(r.frequency).toFixed(2) : "—" },
  // Clics
  { key: "clicks",       label: "Clics totales",render: r => fmt.num(r.clicks) },
  { key: "link_clicks",  label: "Clics enlace", render: r => fmt.num(r.link_clicks) },
  { key: "ctr",          label: "CTR",          render: r => fmt.pct(r.ctr) },
  { key: "cpc",          label: "CPC",          render: r => fmt.eur(r.cpc) },
  { key: "cpm",          label: "CPM",          render: r => fmt.eur(r.cpm) },
  // Resultado principal
  { key: "resultado_valor", label: "Resultados", render: r => r.resultado_valor != null ? fmt.num(r.resultado_valor) : "—",
    sub: r => r.resultado_tipo || null },
  // Meta atribución
  { key: "compras_meta", label: "Compras Meta", render: r => fmt.num(r.compras_meta) },
  { key: "roas_meta",    label: "ROAS Meta",    render: r => fmt.x(r.roas_meta) },
  // Quanty real
  { key: "compras_quanty",  label: "Compras Quanty",  render: r => fmt.num(r.compras_quanty),
    class: r => r.compras_quanty > 0 ? "val-green" : "" },
  { key: "ingresos_quanty", label: "Ingresos Quanty", html: true,
    render: r => {
      const parts = [];
      if (r.ingresos_eur > 0) parts.push(`<span style="color:#4caf50">${fmt.eur(r.ingresos_eur)}</span>`);
      if (r.ingresos_usd > 0) parts.push(`<span style="color:#26c6da">$${Number(r.ingresos_usd).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>`);
      return parts.length ? parts.join(" · ") : "—";
    } },
  { key: "cpa_real",  label: "CPA real",   render: r => fmt.eur(r.cpa_real) },
  { key: "roas_real", label: "ROAS real",  render: r => fmt.x(r.roas_real),
    class: r => r.roas_real != null ? (r.roas_real >= 1 ? "val-green" : "val-red") : "" },
  // Suscriptores Quanty
  { key: "suscriptores",     label: "Suscriptores",       render: r => fmt.num(r.suscriptores),
    sub: r => r.suscriptores > 0 ? "entradas + solicitudes" : null,
    class: r => r.suscriptores > 0 ? "val-green" : "" },
  { key: "coste_suscriptor", label: "Coste/suscriptor",   render: r => fmt.eur(r.coste_suscriptor),
    class: r => r.coste_suscriptor != null ? "val-highlight" : "" },
  // Dispositivos
  { key: "devices_breakdown", label: "Dispositivos", align: "text-left",
    render: r => {
      const d = r.devices_breakdown;
      if (!d || typeof d !== "object") return "—";
      const totalSpend = Object.values(d).reduce((s, v) => s + (v.spend || 0), 0);
      if (!totalSpend) return "—";
      const ICONS = {
        iphone:             "🍎📱",
        ipad:               "🍎📟",
        android_smartphone: "🤖📱",
        android_tablet:     "🤖📟",
        desktop:            "🖥",
        connected_tv:       "📺",
      };
      const LABELS = {
        iphone:             "iPhone",
        ipad:               "iPad",
        android_smartphone: "Android",
        android_tablet:     "Android Tab",
        desktop:            "Desktop",
        connected_tv:       "TV",
      };
      return Object.entries(d)
        .sort(([,a],[,b]) => b.spend - a.spend)
        .map(([dev, v]) => {
          const pct  = totalSpend > 0 ? Math.round(v.spend / totalSpend * 100) : 0;
          const icon = ICONS[dev]  || "❓";
          const lbl  = LABELS[dev] || dev;
          return `${icon} ${lbl} ${pct}%`;
        })
        .join("  ");
    },
  },
];

const GRUPOS_COLUMNAS = [
  { label: "Identificación", cols: TODAS_COLUMNAS.filter(c => ["meta_campaign_name","plantilla_nombre","meta_adset_name","meta_ad_name"].includes(c.key)) },
  { label: "Inversión y alcance", cols: TODAS_COLUMNAS.filter(c => ["spend","impressions","reach","frequency"].includes(c.key)) },
  { label: "Clics y eficiencia", cols: TODAS_COLUMNAS.filter(c => ["clicks","link_clicks","ctr","cpc","cpm"].includes(c.key)) },
  { label: "Resultado campaña", cols: TODAS_COLUMNAS.filter(c => ["resultado_valor"].includes(c.key)) },
  { label: "Meta atribución", cols: TODAS_COLUMNAS.filter(c => ["compras_meta","roas_meta"].includes(c.key)) },
  { label: "Quanty real", cols: TODAS_COLUMNAS.filter(c => ["compras_quanty","ingresos_quanty","cpa_real","roas_real"].includes(c.key)) },
  { label: "Suscriptores", cols: TODAS_COLUMNAS.filter(c => ["suscriptores","coste_suscriptor"].includes(c.key)) },
  { label: "Dispositivos", cols: TODAS_COLUMNAS.filter(c => ["devices_breakdown"].includes(c.key)) },
];

const COLUMNAS_MINIMAS = ["meta_campaign_name","spend","resultado_valor","link_clicks","ctr","suscriptores","coste_suscriptor","compras_quanty","ingresos_quanty","roas_real"];

export default {
  name: "PublicidadMeta",
  directives: {
    clickOutside: {
      mounted(el, binding) {
        el._handler = e => { if (!el.contains(e.target)) binding.value(e); };
        document.addEventListener("click", el._handler);
      },
      unmounted(el) { document.removeEventListener("click", el._handler); },
    },
  },
  data() {
    return {
      PRESETS, GRUPOS_COLUMNAS, fmt,
      presetActivo: null,
      filtros: {
        desde: "",
        hasta: "",
        level: "campaign",
        tipster_id: "",
        campana_id: "",
        con_eliminadas: false,
      },
      filtroOpciones: { tipsters: [], campanas: [] },
      columnasActivas: [...COLUMNAS_MINIMAS],
      mostrarColumnPicker: false,
      busquedaTexto: "",
      filas: [],
      cargando: false,
      sincronizando: false,
      exportandoJson: false,
      buscado: false,
      orden: { key: "spend", asc: false },
      toast: { msg: "", tipo: "ok" },
      // modal vincular
      modalVincular: false,
      campanasNoVinculadas: [],
      vinculaciones: {},
      guardandoVinculos: false,
      cargandoEnlace: false,
      abrirDropdownCampana: null,
      busquedaCampana: {},
      vincPagina: 1,
      vincFiltros: { tipster_id: '', asignacion: 'todos', busqueda: '', desde: '', hasta: '' },
      // modal informe
      modalInforme: false,
      informeFiltros: { tipster_id: '', desde: '', hasta: '' },
      informeFilas: [],
      generandoInforme: false,
      informeBuscado: false,
      quantyLogoUrl: window.location.origin + '/img/quanty.png',
    };
  },
  computed: {
    campanasFiltradas() {
      if (!this.filtros.tipster_id) return this.filtroOpciones.campanas;
      return this.filtroOpciones.campanas.filter(c => String(c.tipster_id) === String(this.filtros.tipster_id));
    },
    campanasPorTipster() {
      const map = {};
      this.filtroOpciones.campanas.forEach(c => {
        if (!map[c.tipster_id]) map[c.tipster_id] = [];
        map[c.tipster_id].push(c);
      });
      return map;
    },
    vinculosParaEnviar() {
      return Object.entries(this.vinculaciones)
        .filter(([, v]) => v.campana_id && v.tipster_id)
        .map(([meta_campaign_id, v]) => ({
          meta_campaign_id,
          campana_id: Number(v.campana_id),
          tipster_id: Number(v.tipster_id),
        }));
    },
    campanasVincFiltradas() {
      let lista = [...this.campanasNoVinculadas].sort((a, b) => {
        const fa = a.fecha_max || '0000-00-00';
        const fb = b.fecha_max || '0000-00-00';
        return fb.localeCompare(fa);
      });
      if (this.vincFiltros.tipster_id) {
        lista = lista.filter(c => {
          const tipsterActual = String(this.vinculaciones[c.meta_campaign_id]?.tipster_id || c.tipster_id || '');
          // Muestra: asignadas a este tipster O sin asignar aún (pendientes de asignar)
          return tipsterActual === this.vincFiltros.tipster_id || tipsterActual === '';
        });
      }
      if (this.vincFiltros.asignacion === 'sin') {
        lista = lista.filter(c => !c.campana_id);
      } else if (this.vincFiltros.asignacion === 'con') {
        lista = lista.filter(c => !!c.campana_id);
      }
      if (this.vincFiltros.desde) {
        lista = lista.filter(c => (c.fecha_max || '') >= this.vincFiltros.desde);
      }
      if (this.vincFiltros.hasta) {
        lista = lista.filter(c => (c.fecha_max || '') <= this.vincFiltros.hasta);
      }
      if (this.vincFiltros.busqueda) {
        const q = this.vincFiltros.busqueda.toLowerCase();
        lista = lista.filter(c => (c.meta_campaign_name || c.meta_campaign_id || '').toLowerCase().includes(q));
      }
      return lista;
    },
    campanasVincTotalPags() {
      return Math.max(1, Math.ceil(this.campanasVincFiltradas.length / 10));
    },
    campanasVincPaginadas() {
      const start = (this.vincPagina - 1) * 10;
      return this.campanasVincFiltradas.slice(start, start + 10);
    },
    columnasVisiblesConfig() {
      return TODAS_COLUMNAS.filter(c => this.columnasActivas.includes(c.key));
    },
    columnasVisibles() {
      return this.columnasActivas;
    },
    informeTotales() {
      const gastado      = this.informeFilas.reduce((s, r) => s + (r.gastado      || 0), 0);
      const suscriptores = this.informeFilas.reduce((s, r) => s + (r.suscriptores || 0), 0);
      const ventas       = this.informeFilas.reduce((s, r) => s + (r.total_ventas || 0), 0);
      const ingresos     = this.informeFilas.reduce((s, r) => s + (r.ingresos     || 0), 0);
      return { gastado, suscriptores, ventas, ingresos, retorno: gastado > 0 ? ingresos / gastado : null };
    },
    informeValido() {
      const { tipster_id, desde, hasta } = this.informeFiltros;
      if (!tipster_id) return false;
      if (!desde || !hasta) return false;
      return desde <= hasta;
    },
    filasFiltradas() {
      const q = this.busquedaTexto.trim().toLowerCase();
      if (!q) return this.filas;
      return this.filas.filter(r =>
        (r.meta_campaign_name || "").toLowerCase().includes(q) ||
        (r.meta_adset_name    || "").toLowerCase().includes(q) ||
        (r.meta_ad_name       || "").toLowerCase().includes(q) ||
        (r.campana_quanty_nombre || "").toLowerCase().includes(q) ||
        (r.plantilla_nombre   || "").toLowerCase().includes(q)
      );
    },
    filasOrdenadas() {
      const { key, asc } = this.orden;
      return [...this.filasFiltradas].sort((a, b) => {
        const va = a[key] ?? -Infinity;
        const vb = b[key] ?? -Infinity;
        if (typeof va === "string") return asc ? va.localeCompare(vb) : vb.localeCompare(va);
        return asc ? va - vb : vb - va;
      });
    },
    totales() {
      const sum = (k) => this.filas.reduce((acc, r) => acc + (Number(r[k]) || 0), 0);
      const spend    = sum("spend");
      const ingresos = sum("ingresos_quanty");
      const ingEur   = sum("ingresos_eur");
      const ingUsd   = sum("ingresos_usd");
      const compras  = sum("compras_quanty");
      return {
        spend,
        ingresos_quanty: ingresos,
        ingresos_eur:    ingEur,
        ingresos_usd:    ingUsd,
        compras_quanty:  compras,
        impressions:     sum("impressions"),
        roas_real: spend > 0 ? ingresos / spend : null,
      };
    },
  },
  async mounted() {
    await Promise.all([this.cargarFiltros(), this.cargar()]);
  },
  methods: {
    async cargarFiltros() {
      try {
        const res = await metaInsightsService.filtros(this.filtros.con_eliminadas);
        if (res?.ok) {
          this.filtroOpciones.tipsters = res.tipsters || [];
          this.filtroOpciones.campanas = res.campanas || [];
          // Si la campaña seleccionada ya no está en la lista, resetearla
          if (this.filtros.campana_id && !res.campanas.find(c => c.id == this.filtros.campana_id)) {
            this.filtros.campana_id = "";
          }
        }
      } catch { /* silencioso — los filtros son opcionales */ }
    },

    onCambioTipster() {
      this.filtros.campana_id = "";
    },

    limpiarEntidad() {
      this.filtros.tipster_id = "";
      this.filtros.campana_id = "";
    },

    aplicarPreset(days) {
      this.presetActivo = days;
      if (days === null) {
        this.filtros.desde = '';
        this.filtros.hasta = '';
        return;
      }
      const hasta = new Date();
      const desde = new Date();
      desde.setDate(desde.getDate() - days);
      this.filtros.hasta = hasta.toISOString().slice(0, 10);
      this.filtros.desde = desde.toISOString().slice(0, 10);
    },

    async cargar() {
      this.cargando = true;
      this.buscado  = false;
      try {
        const res = await metaInsightsService.listar(this.filtros);
        this.filas  = res.data || [];
        this.buscado = true;
      } catch {
        this.mostrarToast("Error al cargar datos.", "err");
      } finally {
        this.cargando = false;
      }
    },

    async sincronizar() {
      this.sincronizando = true;
      try {
        const res = await metaInsightsService.sincronizar(30);
        if (res?.ok) {
          const t = res.totales || {};
          const total = (t.campaign || 0) + (t.adset || 0) + (t.ad || 0);
          if (res.no_vinculadas?.length) {
            this.campanasNoVinculadas = res.no_vinculadas;
            this.vinculaciones = {};
            res.no_vinculadas.forEach(c => {
              this.vinculaciones[c.meta_campaign_id] = { tipster_id: "", campana_id: "" };
            });
            this.modalVincular = true;
          } else {
            await Promise.all([this.cargar(), this.cargarFiltros()]);
            this.mostrarToast(`Sincronizado: ${total} registros importados.`, "ok");
          }
        }
      } catch {
        this.mostrarToast("Error al sincronizar.", "err");
      } finally {
        this.sincronizando = false;
      }
    },

    async abrirModalEnlace() {
      this.cargandoEnlace = true;
      try {
        await this.cargarFiltros();
        const res = await metaInsightsService.campanas();
        if (res?.ok) {
          this.campanasNoVinculadas = res.campanas;
          this.vinculaciones = {};
          res.campanas.forEach(c => {
            this.vinculaciones[c.meta_campaign_id] = {
              tipster_id: c.tipster_id || "",
              campana_id: c.campana_id || "",
            };
          });
          this.modalVincular = true;
        }
      } catch {
        this.mostrarToast("Error al cargar campañas.", "err");
      } finally {
        this.cargandoEnlace = false;
      }
    },

    onCambioTipsterVinculo(metaCampaignId) {
      this.vinculaciones[metaCampaignId].campana_id = "";
      this.busquedaCampana[metaCampaignId] = "";
      this.abrirDropdownCampana = null;
    },
    onCambioFiltroTipster() {
      this.vincPagina = 1;
      if (!this.vincFiltros.tipster_id) return;
      // Pre-rellena el tipster en filas que aún no tienen ninguno seleccionado
      this.campanasNoVinculadas.forEach(c => {
        const vinc = this.vinculaciones[c.meta_campaign_id];
        if (vinc && !vinc.tipster_id) {
          vinc.tipster_id = this.vincFiltros.tipster_id;
        }
      });
    },

    toggleDropdownCampana(metaCampaignId) {
      this.abrirDropdownCampana = this.abrirDropdownCampana === metaCampaignId ? null : metaCampaignId;
    },

    cerrarDropdownCampana(metaCampaignId) {
      if (this.abrirDropdownCampana === metaCampaignId) this.abrirDropdownCampana = null;
    },

    seleccionarCampanaVinculo(metaCampaignId, campanaId) {
      this.vinculaciones[metaCampaignId].campana_id = campanaId;
      this.abrirDropdownCampana = null;
    },

    campanaNombrePorId(id) {
      if (!id) return "";
      const camp = this.filtroOpciones.campanas.find(c => String(c.id) === String(id));
      return camp?.nombre || "";
    },

    gruposCampanasVinculo(metaCampaignId) {
      const vinc = this.vinculaciones[metaCampaignId];
      if (!vinc?.tipster_id) return [];
      const campanas = this.campanasPorTipster[vinc.tipster_id] || [];
      const busq = (this.busquedaCampana[metaCampaignId] || "").toLowerCase().trim();
      const filtradas = busq ? campanas.filter(c => c.nombre.toLowerCase().includes(busq)) : campanas;

      const grupos = {};
      filtradas.forEach(camp => {
        const fecha = camp.created_at ? String(camp.created_at).slice(0, 10) : "0000-00-00";
        if (!grupos[fecha]) grupos[fecha] = { fecha, campanas: [] };
        grupos[fecha].campanas.push(camp);
      });
      return Object.values(grupos).sort((a, b) => b.fecha.localeCompare(a.fecha));
    },

    fmtFechaVinc(fechaStr) {
      if (!fechaStr) return '';
      const [y, m, d] = fechaStr.split('-');
      return `${d}/${m}/${y}`;
    },
    formatFechaGrupo(fechaStr) {
      if (!fechaStr || fechaStr === "0000-00-00") return "Sin fecha";
      const [y, m, d] = fechaStr.split("-");
      const meses = ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"];
      return `${d} - ${meses[parseInt(m, 10) - 1]} - ${y}`;
    },

    async guardarVinculos() {
      if (!this.vinculosParaEnviar.length) {
        this.modalVincular = false;
        return;
      }
      this.guardandoVinculos = true;
      try {
        const res = await metaInsightsService.vincular(this.vinculosParaEnviar);
        if (res?.ok) {
          this.modalVincular = false;
          await Promise.all([this.cargar(), this.cargarFiltros()]);
          this.mostrarToast(`${res.actualizados} landing(s) vinculadas correctamente.`, "ok");
        }
      } catch {
        this.mostrarToast("Error al guardar vínculos.", "err");
      } finally {
        this.guardandoVinculos = false;
      }
    },

    ordenarPor(key) {
      if (this.orden.key === key) {
        this.orden.asc = !this.orden.asc;
      } else {
        this.orden.key = key;
        this.orden.asc = false;
      }
    },

    seleccionarTodas() {
      this.columnasActivas = TODAS_COLUMNAS.map(c => c.key);
    },
    seleccionarMinimas() {
      this.columnasActivas = [...COLUMNAS_MINIMAS];
    },
    cerrarColumnPicker() {
      this.mostrarColumnPicker = false;
    },

    exportarExcel() {
      // Siempre exporta TODAS las columnas, independientemente del picker
      const cols = TODAS_COLUMNAS;
      // Añade columnas extra que son sub-texto (no tienen entrada propia en la tabla)
      const extraCols = ["Campaña Quanty vinculada", "URL landing"];
      const header = [...cols.map(c => c.label), ...extraCols].join("\t");
      const rows = this.filasOrdenadas.map(fila => {
        const celdas = cols.map(c => {
          const raw = fila[c.key];
          if (raw == null) return "";
          if (typeof raw === "number") return String(raw);
          // Para objetos (devices_breakdown) usar render()
          return String(c.render(fila)).replace(/\t|\n/g, " ");
        });
        celdas.push(
          (fila.campana_quanty_nombre || "").replace(/\t|\n/g, " "),
          fila.landing_slug ? `/${fila.landing_slug}` : ""
        );
        return celdas.join("\t");
      });
      const tsv  = [header, ...rows].join("\n");
      const blob = new Blob(["﻿" + tsv], { type: "text/tab-separated-values;charset=utf-8" });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href     = url;
      a.download = `publicidad_meta_${this.filtros.desde}_${this.filtros.hasta}.xls`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },

    async exportarJson() {
      if (this.exportandoJson) return;
      if (!this.filtros.desde || !this.filtros.hasta) {
        this.mostrarToast('Selecciona un rango de fechas antes de descargar', 'error');
        return;
      }
      this.exportandoJson = true;
      try {
        const data = await metaInsightsService.exportarJson(this.filtros.desde, this.filtros.hasta, { tipster_id: this.filtros.tipster_id || null });
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
        const url  = URL.createObjectURL(blob);
        const a    = document.createElement('a');
        a.href     = url;
        a.download = `quanty_meta_${this.filtros.desde}_${this.filtros.hasta}.json`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (e) {
        this.mostrarToast('Error al generar el JSON', 'error');
      } finally {
        this.exportandoJson = false;
      }
    },

    mostrarToast(msg, tipo = "ok") {
      this.toast = { msg, tipo };
      setTimeout(() => { this.toast.msg = ""; }, 4000);
    },

    abrirModalInforme() {
      this.informeFiltros.desde = '';
      this.informeFiltros.hasta = '';
      this.informeFiltros.tipster_id = '';
      this.informeFilas = [];
      this.informeBuscado = false;
      this.modalInforme = true;
    },

    async generarInforme() {
      this.generandoInforme = true;
      this.informeBuscado = false;
      try {
        const res = await metaInsightsService.informe({
          tipster_id: this.informeFiltros.tipster_id || null,
          desde: this.informeFiltros.desde,
          hasta: this.informeFiltros.hasta,
        });
        if (res?.ok) {
          // Normalizar códigos de país (2→3 letras) y fusionar duplicados
          const NORM = {
            US:'USA', UK:'GBR', GB:'GBR', ES:'ESP', MX:'MEX', AR:'ARG',
            BR:'BRA', CO:'COL', PE:'PER', CL:'CHL', AU:'AUS', CA:'CAN',
            DE:'DEU', FR:'FRA', IT:'ITA', PT:'PRT', NL:'NLD', BE:'BEL',
            CH:'CHE', AT:'AUT', PL:'POL', SE:'SWE', NO:'NOR', DK:'DNK',
            FI:'FIN', IE:'IRL', TR:'TUR', IN:'IND', JP:'JPN', KR:'KOR',
          };
          const merged = {};
          for (const f of res.filas || []) {
            const paisClean = (f.pais || '').trim();
            const key = NORM[paisClean.toUpperCase()] || paisClean || '—';
            if (!merged[key]) {
              merged[key] = { ...f, pais: key };
            } else {
              merged[key].gastado      += f.gastado;
              merged[key].suscriptores += f.suscriptores;
              merged[key].total_ventas += f.total_ventas;
              merged[key].ingresos     += f.ingresos;
              merged[key].coste_susc   = merged[key].suscriptores > 0
                ? +( merged[key].gastado / merged[key].suscriptores).toFixed(2) : null;
              merged[key].retorno      = merged[key].gastado > 0
                ? +(merged[key].ingresos / merged[key].gastado).toFixed(2) : null;
            }
          }
          this.informeFilas = Object.values(merged).sort((a, b) => b.gastado - a.gastado);
          this.informeBuscado = true;
        }
      } catch {
        this.mostrarToast('Error al generar el informe.', 'err');
      } finally {
        this.generandoInforme = false;
      }
    },

    fmtNum(v) {
      if (v == null) return '—';
      return Number(v).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    imprimirInforme() {
      const logoUrl  = window.location.origin + '/img/quanty.png';
      const tipsterNombre = this.informeFiltros.tipster_id
        ? (this.filtroOpciones.tipsters.find(t => String(t.id) === String(this.informeFiltros.tipster_id))?.nombre || 'Todos')
        : 'Todos los tipsters';
      const fechaGen = new Date().toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' });
      const periodo  = `${this.informeFiltros.desde} → ${this.informeFiltros.hasta}`;

      const filas = this.informeFilas.map(f => {
        const retornoTxt = f.retorno != null ? this.fmtNum(f.retorno) + 'x' : '—';
        const retornoClass = f.retorno >= 1 ? 'pos' : f.retorno != null ? 'neg' : '';
        const costeTxt = f.coste_susc != null ? '$' + this.fmtNum(f.coste_susc) : '—';
        return `<tr>
          <td>${f.pais}</td>
          <td class="r">$${this.fmtNum(f.gastado)}</td>
          <td class="r">${f.suscriptores}</td>
          <td class="r">${costeTxt}</td>
          <td class="r">${f.total_ventas}</td>
          <td class="r ${retornoClass}">${retornoTxt}</td>
        </tr>`;
      }).join('');

      const tot = this.informeTotales;
      const totRetorno = tot.gastado > 0 ? this.fmtNum(tot.ingresos / tot.gastado) + 'x' : '—';
      const totRetClass = (tot.ingresos / tot.gastado) >= 1 ? 'pos' : tot.gastado > 0 ? 'neg' : '';
      const totCoste = tot.suscriptores > 0 ? '$' + this.fmtNum(tot.gastado / tot.suscriptores) : '—';

      const html = `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>Resumen de Campañas — ${periodo}</title>
  <style>
    *{box-sizing:border-box;margin:0;padding:0}
    body{font-family:Arial,sans-serif;font-size:12px;color:#222;padding:32px}
    .header{display:flex;align-items:center;gap:18px;margin-bottom:24px;border-bottom:2px solid #d4af37;padding-bottom:16px}
    img.logo{max-height:52px;object-fit:contain}
    .header-txt h1{font-size:18px;font-weight:bold;color:#1a1a1a;margin-bottom:3px}
    .header-txt p{font-size:11px;color:#777}
    .meta{font-size:11px;color:#555;margin-bottom:20px;display:flex;gap:24px}
    .meta span b{color:#1a1a1a}
    table{width:100%;border-collapse:collapse}
    th{background:#1a1a2e;color:#d4af37;padding:8px 12px;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:.5px}
    th.r,td.r{text-align:right}
    td{padding:8px 12px;border-bottom:1px solid #eee;font-size:12px}
    tr:nth-child(even) td{background:#f9f9f9}
    .total-row td{background:#f0f4ff!important;font-weight:bold;border-top:2px solid #1a1a2e}
    .pos{color:#2e7d32;font-weight:700}
    .neg{color:#c62828;font-weight:700}
    @page{margin:1.5cm}
    @media print{body{padding:0}}
  </style>
</head>
<body>
  <div class="header">
    <img src="${logoUrl}" class="logo" alt="Quanty">
    <div class="header-txt">
      <h1>Resumen de Campañas</h1>
      <p>Desglose por País</p>
    </div>
  </div>
  <div class="meta">
    <span><b>Tipster:</b> ${tipsterNombre}</span>
    <span><b>Período:</b> ${periodo}</span>
    <span><b>Generado:</b> ${fechaGen}</span>
  </div>
  <table>
    <thead>
      <tr>
        <th>País</th>
        <th class="r">Gastado</th>
        <th class="r">Suscriptores</th>
        <th class="r">Coste susc.</th>
        <th class="r">Total ventas</th>
        <th class="r">Retorno</th>
      </tr>
    </thead>
    <tbody>${filas}</tbody>
    <tfoot>
      <tr class="total-row">
        <td><strong>TOTAL</strong></td>
        <td class="r"><strong>$${this.fmtNum(tot.gastado)}</strong></td>
        <td class="r"><strong>${tot.suscriptores}</strong></td>
        <td class="r"><strong>${totCoste}</strong></td>
        <td class="r"><strong>${tot.ventas}</strong></td>
        <td class="r ${totRetClass}"><strong>${totRetorno}</strong></td>
      </tr>
    </tfoot>
  </table>
</body>
</html>`;

      const win = window.open('', '_blank');
      if (!win) {
        this.mostrarToast('Permite ventanas emergentes para generar el PDF.', 'err');
        return;
      }
      win.document.write(html);
      win.document.close();
      win.focus();
      setTimeout(() => win.print(), 600);
    },

    paisToFlag(pais) {
      if (!pais || pais === '—') return 'xx';
      const MAP = {
        // ISO 3166-1 alpha-3
        ESP: 'es', MEX: 'mx', ARG: 'ar', COL: 'co', PER: 'pe', CHL: 'cl',
        BRA: 'br', USA: 'us', GBR: 'gb', DEU: 'de', FRA: 'fr', ITA: 'it',
        PRT: 'pt', VEN: 've', ECU: 'ec', BOL: 'bo', PRY: 'py', URY: 'uy',
        CRI: 'cr', PAN: 'pa', DOM: 'do', GTM: 'gt', HND: 'hn', SLV: 'sv',
        NIC: 'ni', CUB: 'cu', PRI: 'pr', AND: 'ad', CHE: 'ch', BEL: 'be',
        NLD: 'nl', AUT: 'at', POL: 'pl', ROU: 'ro', HUN: 'hu', CZE: 'cz',
        SVK: 'sk', BGR: 'bg', HRV: 'hr', SRB: 'rs', GRC: 'gr', TUR: 'tr',
        MAR: 'ma', DZA: 'dz', TUN: 'tn', EGY: 'eg', NGA: 'ng', ZAF: 'za',
        KEN: 'ke', GHA: 'gh', JPN: 'jp', KOR: 'kr', CHN: 'cn', IND: 'in',
        AUS: 'au', NZL: 'nz', CAN: 'ca', IRL: 'ie', SWE: 'se', NOR: 'no',
        DNK: 'dk', FIN: 'fi', PHL: 'ph', IDN: 'id', MYS: 'my', SGP: 'sg',
        THA: 'th', VNM: 'vn', PAK: 'pk', BGD: 'bd', LKA: 'lk', NPL: 'np',
        // Alias cortos que Meta puede usar
        UK: 'gb', GB: 'gb', US: 'us', ES: 'es', MX: 'mx', AR: 'ar',
        BR: 'br', CO: 'co', PE: 'pe', CL: 'cl', AU: 'au', CA: 'ca',
        DE: 'de', FR: 'fr', IT: 'it', PT: 'pt', NL: 'nl', BE: 'be',
        CH: 'ch', AT: 'at', PL: 'pl', SE: 'se', NO: 'no', DK: 'dk',
        FI: 'fi', IE: 'ie', TR: 'tr', IN: 'in', JP: 'jp', KR: 'kr',
      };
      const key = pais.toUpperCase();
      return MAP[key] || pais.toLowerCase().slice(0, 2);
    },
  },
};
</script>

<style scoped>
/* ── Layout ─────────────────────────────────────────────── */
.pub-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
}
.pub-title    { color: var(--q-text); font-family: var(--q-font-display); font-size: 20px; font-weight: 700; margin: 0; }
.pub-subtitle { color: var(--q-muted); font-size: 13px; margin: 2px 0 0; }
.pub-header-actions { display: flex; gap: 8px; flex-wrap: wrap; }

.pub-card {
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: var(--q-radius);
  padding: 20px;
}

/* ── Filtros ─────────────────────────────────────────────── */
.pub-filtros {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
}
.pub-filtros--entidad { align-items: flex-end; }
.pub-filtros-sep {
  border: none;
  border-top: 1px solid var(--q-border);
  margin: 0;
}
.filtro-group { display: flex; flex-direction: column; gap: 4px; position: relative; }
.filtro-group--center { justify-content: flex-end; }
.filtro-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: var(--q-muted);
}
.filtro-input {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-text);
  padding: 7px 10px;
  font-size: 13px;
  outline: none;
  min-width: 130px;
  max-width: 200px;
}
.filtro-input--wide {
  min-width: 200px;
  max-width: 280px;
}
.filtro-input:focus { border-color: var(--q-gold); }

.filtro-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--q-muted);
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  padding: 7px 0;
}
.filtro-toggle input[type="checkbox"] {
  cursor: pointer;
  accent-color: var(--q-gold);
}
.filtro-toggle:hover { color: var(--q-text); }

.btn-filtro-clear {
  background: none;
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-muted);
  font-size: 12px;
  padding: 7px 12px;
  cursor: pointer;
  white-space: nowrap;
  transition: all .15s;
}
.btn-filtro-clear:hover {
  border-color: var(--q-red, #ff4444);
  color: var(--q-red, #ff4444);
}

.preset-btns { display: flex; gap: 4px; }
.btn-preset {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 5px;
  color: var(--q-muted);
  font-size: 12px;
  font-weight: 600;
  padding: 5px 10px;
  cursor: pointer;
  transition: all .15s;
}
.btn-preset.active,
.btn-preset:hover { background: var(--q-gold); color: var(--q-gold-on); border-color: var(--q-gold); }

/* ── Column picker ───────────────────────────────────────── */
.btn-column-picker {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-text);
  padding: 7px 12px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.btn-column-picker:hover { border-color: var(--q-gold); }

.column-picker-panel {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 300;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 10px;
  padding: 12px;
  width: 240px;
  max-height: 380px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0,0,0,.5);
}
.cp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  color: var(--q-text);
}
.cp-actions { display: flex; gap: 4px; align-items: center; }
.cp-link {
  background: none;
  border: none;
  color: var(--q-gold);
  font-size: 11px;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}
.cp-sep { color: var(--q-muted); font-size: 10px; }
.cp-group { margin-bottom: 10px; }
.cp-group-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: var(--q-gold);
  margin-bottom: 4px;
  padding-bottom: 3px;
  border-bottom: 1px solid var(--q-border);
}
.cp-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--q-text);
  padding: 3px 0;
  cursor: pointer;
}
.cp-row input[type="checkbox"] { cursor: pointer; accent-color: var(--q-gold); }

/* ── Botones ─────────────────────────────────────────────── */
.btn-pub-primary {
  background: var(--q-gold);
  color: var(--q-gold-on);
  border: none;
  border-radius: 6px;
  padding: 8px 20px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.btn-pub-primary:hover:not(:disabled) { background: var(--q-gold-hover); }
.btn-pub-primary:disabled { opacity: .5; cursor: not-allowed; }

.btn-pub-secondary {
  background: var(--q-hover);
  color: var(--q-text);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.btn-pub-secondary:hover:not(:disabled) { border-color: var(--q-gold); }
.btn-pub-secondary:disabled { opacity: .5; cursor: not-allowed; }

/* ── KPI cards ───────────────────────────────────────────── */
.kpi-row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}
.kpi-card {
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: var(--q-radius);
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.kpi-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--q-muted); }
.kpi-value { font-size: 20px; font-weight: 800; color: var(--q-text); font-variant-numeric: tabular-nums; font-family: var(--q-font-display); }
.kpi-green { color: var(--q-green); }
.kpi-red   { color: var(--q-red); }

/* ── Tabla ───────────────────────────────────────────────── */
.tabla-wrap { overflow-x: auto; }
.pub-table { width: 100%; border-collapse: collapse; font-size: 13px; }

.pub-th {
  color: var(--q-muted);
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .5px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--q-border-md);
  white-space: nowrap;
  user-select: none;
}
.pub-th:hover { color: var(--q-gold); }

.pub-tr { border-bottom: 1px solid var(--q-border); transition: background .1s; }
.pub-tr:hover { background: var(--q-hover); }
.pub-tr:last-child { border-bottom: none; }

.pub-td {
  padding: 9px 12px;
  color: var(--q-text);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.text-left  { text-align: left; }
.text-right { text-align: right; }
.val-green      { color: var(--q-green);  font-weight: 700; }
.val-red        { color: var(--q-red);    font-weight: 700; }
.val-highlight  { color: var(--q-accent); font-weight: 700; }

.pub-td-sub {
  display: block;
  font-size: 10px;
  color: var(--q-muted);
  font-weight: 400;
  margin-top: 2px;
  white-space: nowrap;
}

/* ── Estados vacíos / carga ──────────────────────────────── */
.pub-loading, .pub-empty {
  text-align: center;
  padding: 60px 24px;
  color: var(--q-muted);
  font-size: 14px;
}
.pub-empty-hint { font-size: 12px; margin-top: 6px; }

/* ── Toast ───────────────────────────────────────────────── */
.pub-toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 999;
  padding: 12px 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 4px 16px rgba(0,0,0,.4);
}
.pub-toast--ok  { background: var(--q-green-soft); color: var(--q-green); border: 1px solid var(--q-green); }
.pub-toast--err { background: var(--q-red-soft);   color: var(--q-red);   border: 1px solid var(--q-red); }

/* ── Breadcrumb ──────────────────────────────────────────── */
.breadcrumb { background: transparent; padding: 0; }
.breadcrumb-item { cursor: pointer; color: var(--q-gold); }
.breadcrumb-item:hover { text-decoration: underline; }

/* ── Responsive ──────────────────────────────────────────── */
@media (max-width: 768px) {
  .pub-header { flex-direction: column; }
  .pub-filtros { gap: 10px; }
  .filtro-input--wide { min-width: 100%; max-width: 100%; }
  .kpi-row { grid-template-columns: repeat(2, 1fr); }
  .column-picker-panel { left: auto; right: 0; }
}

/* ── Modal vincular ──────────────────────────────────────── */
.vinc-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.65);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.vinc-modal {
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: 12px;
  width: 100%;
  max-width: 960px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 16px 48px rgba(0,0,0,.6);
}
.vinc-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--q-border);
  gap: 12px;
}
.vinc-title   { margin: 0; font-size: 16px; font-weight: 700; color: var(--q-text); }
.vinc-subtitle { margin: 4px 0 0; font-size: 12px; color: var(--q-muted); line-height: 1.4; }
.vinc-close {
  background: none;
  border: none;
  color: var(--q-muted);
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  flex-shrink: 0;
}
.vinc-close:hover { color: var(--q-text); }

.vinc-empty {
  padding: 32px 24px;
  color: var(--q-muted);
  font-size: 13px;
  text-align: center;
  line-height: 1.6;
}

.vinc-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}
.vinc-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  border-bottom: 1px solid var(--q-border);
  flex-wrap: wrap;
}
.vinc-row:last-child { border-bottom: none; }
/* ── Filtros ─────────────────────────────────────── */
.vinc-filtros {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--q-border);
  background: var(--q-hover);
}
.vinc-filtro-search {
  flex: 1;
  min-width: 160px;
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-text);
  padding: 6px 10px;
  font-size: 12px;
  outline: none;
}
.vinc-filtro-search:focus { border-color: var(--q-gold); }
.vinc-filtro-tipster { min-width: 150px; }
.vinc-filtro-tabs {
  display: flex;
  gap: 2px;
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  padding: 2px;
}
.vinc-tab {
  background: none;
  border: none;
  border-radius: 4px;
  color: var(--q-muted);
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  cursor: pointer;
  white-space: nowrap;
}
.vinc-tab--active { background: var(--q-gold); color: var(--q-gold-on); }
.vinc-tab:not(.vinc-tab--active):hover { color: var(--q-text); }
.vinc-filtro-fechas {
  display: flex;
  align-items: center;
  gap: 4px;
}
.vinc-filtro-fecha {
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-text);
  padding: 5px 8px;
  font-size: 11px;
  outline: none;
  width: 120px;
}
.vinc-filtro-fecha:focus { border-color: var(--q-gold); }
.vinc-filtro-sep { color: var(--q-muted); font-size: 11px; }

/* ── Contador ────────────────────────────────────── */
.vinc-counter {
  padding: 6px 20px;
  font-size: 11px;
  color: var(--q-muted);
  border-bottom: 1px solid var(--q-border);
}

/* ── Meta name con fecha ─────────────────────────── */
.vinc-meta-name {
  flex: 1;
  min-width: 200px;
  font-size: 13px;
  color: var(--q-text);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}
.vinc-meta-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.vinc-meta-nombre {
  font-size: 13px;
  font-weight: 600;
  color: var(--q-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vinc-meta-fecha {
  font-size: 10px;
  font-weight: 400;
  color: var(--q-muted);
}

/* ── Paginación ──────────────────────────────────── */
.vinc-paginacion {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 20px;
  border-top: 1px solid var(--q-border);
}
.vinc-pag-btn {
  background: none;
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-muted);
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vinc-pag-btn:disabled { opacity: .35; cursor: not-allowed; }
.vinc-pag-btn:not(:disabled):hover { border-color: var(--q-gold); color: var(--q-text); }
.vinc-pag-num {
  background: none;
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-muted);
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
}
.vinc-pag-num:hover { border-color: var(--q-gold); color: var(--q-text); }
.vinc-pag-num--active { background: var(--q-gold); border-color: var(--q-gold); color: var(--q-gold-on); cursor: default; }

.vinc-badge {
  background: #1877F2;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  flex-shrink: 0;
}
.vinc-badge-linked {
  background: var(--q-green-soft);
  color: var(--q-green);
  border: 1px solid var(--q-green);
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  flex-shrink: 0;
}
.vinc-selects {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.vinc-select {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-text);
  padding: 6px 10px;
  font-size: 12px;
  outline: none;
  min-width: 160px;
  max-width: 200px;
}
.vinc-select:focus  { border-color: var(--q-gold); }
.vinc-select:disabled { opacity: .45; cursor: not-allowed; }

.vinc-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--q-border);
}
.vinc-btn-skip {
  background: none;
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-muted);
  font-size: 13px;
  padding: 8px 16px;
  cursor: pointer;
}
.vinc-btn-skip:hover { border-color: var(--q-gold); color: var(--q-text); }
.vinc-btn-save {
  background: var(--q-gold);
  color: var(--q-gold-on);
  border: none;
  border-radius: 6px;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.vinc-btn-save:hover:not(:disabled) { background: var(--q-gold-hover); }
.vinc-btn-save:disabled { opacity: .45; cursor: not-allowed; }

/* ── Dropdown custom campaña ─────────────────────────── */
.vinc-dd {
  position: relative;
  min-width: 180px;
  max-width: 240px;
}
.vinc-dd--disabled { opacity: .45; pointer-events: none; }

.vinc-dd-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-text);
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
  text-align: left;
  outline: none;
}
.vinc-dd-trigger:focus { border-color: var(--q-gold); }
.vinc-dd-trigger:disabled { opacity: .45; cursor: not-allowed; }

.vinc-dd-valor {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vinc-dd-chevron {
  font-size: 10px;
  color: var(--q-muted);
  flex-shrink: 0;
  transition: transform .15s;
}

.vinc-dd-panel {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 200;
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0,0,0,.35);
  width: 240px;
  min-width: 100%;
}

.vinc-dd-search-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-bottom: 1px solid var(--q-border);
}
.vinc-dd-search-icon { font-size: 11px; color: var(--q-muted); }
.vinc-dd-search-input {
  flex: 1;
  background: none;
  border: none;
  outline: none;
  color: var(--q-text);
  font-size: 12px;
}
.vinc-dd-search-input::placeholder { color: var(--q-muted); }

.vinc-dd-scroll { max-height: 260px; overflow-y: auto; }

.vinc-dd-date-header {
  padding: 7px 10px 3px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: var(--q-gold);
}

.vinc-dd-opt {
  padding: 7px 14px;
  font-size: 12px;
  color: var(--q-text);
  cursor: pointer;
}
.vinc-dd-opt:hover { background: var(--q-hover); }
.vinc-dd-opt--active { color: var(--q-gold); font-weight: 600; }
.vinc-dd-opt--none { color: var(--q-muted); font-style: italic; }

.vinc-dd-empty {
  padding: 12px;
  text-align: center;
  font-size: 12px;
  color: var(--q-muted);
}

@media (max-width: 600px) {
  .vinc-row { flex-direction: column; align-items: flex-start; }
  .vinc-select { min-width: 100%; max-width: 100%; }
  .vinc-dd { min-width: 100%; max-width: 100%; }
  .vinc-dd-panel { width: 100%; }
}

/* ── Búsqueda manual ─────────────────────────────────────── */
.busqueda-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0 2px;
  flex-wrap: wrap;
}
.busqueda-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--q-card-alt, rgba(255,255,255,.05));
  border: 1px solid var(--q-border-md);
  border-radius: 8px;
  padding: 7px 12px;
  flex: 1;
  min-width: 240px;
  max-width: 480px;
}
.busqueda-icon { font-size: 12px; color: var(--q-muted); flex-shrink: 0; }
.busqueda-input {
  flex: 1;
  background: none;
  border: none;
  outline: none;
  color: var(--q-text);
  font-size: 13px;
}
.busqueda-input::placeholder { color: var(--q-muted); }
.busqueda-clear {
  background: none;
  border: none;
  color: var(--q-muted);
  cursor: pointer;
  padding: 0;
  font-size: 12px;
  line-height: 1;
}
.busqueda-clear:hover { color: var(--q-text); }
.busqueda-count {
  font-size: 12px;
  color: var(--q-muted);
  white-space: nowrap;
}

/* ── Botón Informe ───────────────────────────────────────── */
.btn-pub-informe {
  background: linear-gradient(135deg, rgba(212,175,55,.18), rgba(212,175,55,.08));
  border-color: var(--q-gold) !important;
  color: var(--q-gold) !important;
}
.btn-pub-informe:hover {
  background: linear-gradient(135deg, rgba(212,175,55,.30), rgba(212,175,55,.15));
}

/* ── Modal Informe ───────────────────────────────────────── */
.inf-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.65);
  z-index: 9100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.inf-modal {
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: 12px;
  width: 100%;
  max-width: 780px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.inf-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--q-border);
  background: linear-gradient(135deg, rgba(212,175,55,.07), transparent);
  flex-shrink: 0;
}
.inf-header-logo {
  display: flex;
  align-items: center;
  gap: 14px;
}
.inf-logo {
  height: 40px;
  object-fit: contain;
}
.inf-titulo {
  font-family: var(--q-font-display);
  font-size: 18px;
  font-weight: 700;
  color: var(--q-gold);
  line-height: 1.2;
}
.inf-subtitulo {
  font-size: 12px;
  color: var(--q-muted);
  margin-top: 2px;
}
.inf-close {
  background: none;
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-muted);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .15s;
}
.inf-close:hover { border-color: var(--q-text); color: var(--q-text); }

.inf-filtros {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid var(--q-border);
  flex-shrink: 0;
}

.btn-inf-generar {
  background: var(--q-gold);
  color: #000;
  border: none;
  border-radius: 6px;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity .15s;
}
.btn-inf-generar:disabled { opacity: .6; cursor: default; }
.btn-inf-generar:not(:disabled):hover { opacity: .85; }

.btn-inf-pdf {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-text);
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all .15s;
}
.btn-inf-pdf:hover { border-color: var(--q-gold); color: var(--q-gold); }

.inf-tabla-wrap {
  overflow: auto;
  flex: 1;
  padding: 16px 24px 24px;
}

.inf-tabla {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.inf-tabla th {
  background: var(--q-card-alt);
  color: var(--q-muted);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .5px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--q-border-md);
  white-space: nowrap;
}
.inf-tabla td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--q-border);
  color: var(--q-text);
}
.inf-tabla tbody tr:hover td { background: var(--q-hover); }
.td-num { text-align: right; font-variant-numeric: tabular-nums; }
.td-pais { display: flex; align-items: center; gap: 8px; }
.inf-flag { font-size: 18px; border-radius: 3px; }
.inf-pais-nombre { font-weight: 600; }
.inf-retorno.pos { color: #4caf50; font-weight: 700; }
.inf-retorno.neg { color: #f44336; font-weight: 700; }

.inf-total-row td {
  background: var(--q-card-alt);
  border-top: 2px solid var(--q-border-md);
  border-bottom: none;
}

.inf-empty {
  padding: 40px;
  text-align: center;
  color: var(--q-muted);
  font-size: 14px;
}
.inf-empty i { margin-right: 8px; }

@media (max-width: 600px) {
  .inf-filtros { gap: 10px; }
  .inf-tabla-wrap { padding: 12px 12px 16px; }
}
</style>
